export const APPEAR_TRANSITION_DURATION = 180;
export const APPEAR_TRANSITION_POSITIONS = [...['auto', 'top', 'bottom', 'left', 'right'].reduce((acc, p) => [...acc, p, `${p}-start`, `${p}-end`], [])];
export const APPEAR_TRANSITION_TYPES = ['slide', 'zoom'];